const Logger = () => {
  // Disabling no-unused-vars rule so that our SSR stub method signatures match the client-side implementation.
  const result = {
    /* eslint-disable no-unused-vars */
    debug: (info) => { },
    error: (error) => { },
    log: (log) => { },
    warn: (warning) => { },
    /* eslint-enable no-unused-vars */
  };
  if (typeof window === 'undefined') {
    return result;
  }
  const isLocal = window.location.hostname === 'localhost';

  result.debug = (info) => {
    if (isLocal) {
      window.console?.debug?.(info);
    }
    if (window.trackJs && !isLocal) {
      window.trackJs?.console?.debug?.(info);
    }
  };
  result.error = (error) => {
    if (isLocal) {
      window.console?.error?.(error);
    }
    if (window.trackJs && !isLocal) {
      window.trackJs?.track?.(error);
    }
    if (window.DD_RUM && !isLocal) {
      window.DD_RUM?.addError?.(error);
    }
  };
  result.log = (log) => {
    if (isLocal) {
      window.console?.log?.(log);
    }
    if (window.trackJs && !isLocal) {
      window.trackJs?.console?.log?.(log);
    }
  };
  result.warn = (warning) => {
    if (isLocal) {
      window.console?.warn?.(warning);
    }
    if (window.trackJs && !isLocal) {
      window.trackJs?.console?.warn?.(warning);
    }
  };
  return result;
};

export default Logger();
export { Logger as ComponentUnderTest };
